const indexItems = [
  { id: 1, icon: 'ri-rocket-line', title: '科幻巨制', count: '326部', desc: '星际探险、人工智能、未来世界' },
  { id: 2, icon: 'ri-heart-pulse-line', title: '爱情文艺', count: '418部', desc: '浪漫邂逅、心动故事、情感共鸣' },
  { id: 3, icon: 'ri-sword-line', title: '动作冒险', count: '552部', desc: '热血格斗、极限追击、视觉盛宴' },
  { id: 4, icon: 'ri-emotion-laugh-line', title: '喜剧搞笑', count: '389部', desc: '轻松一刻、爆笑不断、解压必备' },
  { id: 5, icon: 'ri-ghost-line', title: '悬疑惊悚', count: '271部', desc: '烧脑推理、细思极恐、反转连连' },
  { id: 6, icon: 'ri-palette-line', title: '动画世界', count: '203部', desc: '童年回忆、全家欢聚、视觉奇观' },
  { id: 7, icon: 'ri-history-line', title: '经典老片', count: '480部', desc: '影史瑰宝、永恒佳作、百看不厌' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-200 text-secondary-700 text-xs font-medium mb-3">
            <i className="ri-stack-line mr-1"></i>分类导航
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">影视专题</h2>
          <p className="text-sm text-foreground-500 mt-2 max-w-lg mx-auto">按题材快速找到你想看的电影类型</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-7 gap-4">
          {indexItems.map((item) => (
            <div
              key={item.id}
              className="group bg-background-100 rounded-xl p-5 border border-secondary-200/50 cursor-pointer hover:border-primary-300 hover:bg-primary-50/30 transition-all duration-200 text-center"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-secondary-100 text-secondary-600 group-hover:bg-primary-100 group-hover:text-primary-600 mx-auto mb-3 transition-colors">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-sm font-bold text-foreground-950 mb-1">{item.title}</h3>
              <p className="text-xs text-primary-600 font-medium mb-1">{item.count}</p>
              <p className="text-xs text-foreground-400 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}